import { render } from "./accessoryForm.vue?vue&type=template&id=fdf7448c&scoped=true"
import script from "./accessoryForm.vue?vue&type=script&lang=js"
export * from "./accessoryForm.vue?vue&type=script&lang=js"

import "./accessoryForm.vue?vue&type=style&index=0&id=fdf7448c&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-accounting-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdf7448c"]])

export default __exports__